import { VideoIcon } from './VideoIcon';

/**
 * author: Google
 * id B1337ECC-EF1F-481B-9E75-6A8DB7A01BB9
 * name video
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video.svg
 * tags
 * - Video / Movie 
 * - Home Automation 
 */
export const VideocamIcon = VideoIcon;
export default VideocamIcon